import BoxWithShadow from "../../common/components/BoxWithShadow";
import Loader from "../../common/components/Loader";
import CountCard from "../../common/components/CountCard";
import { useGetYearlyUserTrendAsAdminQuery } from "../../../lib/apollo/graphql/generated";
import { Bar } from "react-chartjs-2";
import { formatDate } from "../../../utilities/format";

const getCharLabels = () => {
  const today = new Date();

  return Array.from({ length: 12 }).map((_, index) => {
    const date = new Date(
      today.getFullYear(),
      today.getMonth() - 11 + index,
      1
    );

    return formatDate(date.toISOString(), "YY년 MM월");
  });
};

export default function UserStats() {
  const { data, loading } = useGetYearlyUserTrendAsAdminQuery();

  if (loading) {
    return (
      <BoxWithShadow className="h-[700px] min-h-[700px]">
        <Loader />
      </BoxWithShadow>
    );
  }

  const trends = data?.getYearlyUserTrendAsAdmin;
  const labels = getCharLabels();

  const allCounts =
    trends?.flatMap((trend) => [
      trend?.caregiverCount || 0,
      trend?.guardianCount || 0,
      trend?.receiverCount || 0,
      trend?.resignedUsersCount || 0,
    ]) || [];
  const maxY = Math.max(...allCounts, 0);

  return (
    <BoxWithShadow className="h-[700px] min-h-[700px] p-0">
      <div className="flex h-full gap-5">
        <div className="flex w-1/6 flex-shrink-0 flex-col items-start gap-1 py-5 ps-3">
          <p className="text-lg font-bold">이번달 사용자 현황</p>
          <CountCard
            label="신규 보호사"
            count={trends?.at(-1)?.caregiverCount}
            unit="명"
          />
          <CountCard
            label="신규 보호자"
            count={trends?.at(-1)?.guardianCount}
            unit="명"
          />
          <CountCard
            label="신규 수급자"
            count={trends?.at(-1)?.receiverCount}
            unit="명"
          />
          <CountCard
            label="탈퇴 사용자"
            count={trends?.at(-1)?.resignedUsersCount}
            unit="명"
          />
        </div>
        <div className="flex h-full w-full flex-col gap-3 py-5 pe-3">
          <p className="text-lg font-bold">1년 사용자 현황</p>
          <div className="h-full">
            <Bar
              id="user-stats-chart"
              style={{
                width: "100%",
                height: "100%",
              }}
              options={{
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    position: "bottom",
                  },
                },
                scales: {
                  x: {
                    grid: {
                      display: false,
                    },
                    ticks: {
                      color: "#666",
                    },
                  },
                  y: {
                    ticks: {
                      stepSize: 5,
                      color: "#666",
                    },
                    beginAtZero: true,
                    max: maxY,
                  },
                },
              }}
              data={{
                labels,
                datasets: [
                  {
                    label: "보호사",
                    data: trends?.map((trend) => trend?.caregiverCount),
                    backgroundColor: "#18e6c4",
                  },
                  {
                    label: "보호자",
                    data: trends?.map((trend) => trend?.guardianCount),
                    backgroundColor: "#f07912",
                  },
                  {
                    label: "수급자",
                    data: trends?.map((trend) => trend?.receiverCount),
                    backgroundColor: "#2e82bf",
                  },
                  {
                    label: "탈퇴",
                    data: trends?.map((trend) => trend?.resignedUsersCount),
                    backgroundColor: "#c4c4c4",
                  },
                ],
              }}
            />
          </div>
        </div>
      </div>
    </BoxWithShadow>
  );
}
